import initialState from './CampaignsInitialState';
import reducers from './CampaignsReducer';

export default {
  initialState,
  reducers,
};
